import {
  Button,
  Checkbox,
  Divider,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { links } from '@shared/utils';
import { FileDown } from 'lucide-react';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

type SummaryTermsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
};

export const SummaryTermsModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
}: SummaryTermsModalProps) => {
  const { t } = useTranslation('checkout/summary');

  const [isChecked, setIsChecked] = useState(false);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex flexDir="column">
            <Text fontSize="3xl" fontWeight="semibold">
              {t('termsTitle')}
            </Text>
            <Text fontSize="lg" fontWeight={400} color="neutral.700">
              {t('termsDescription')}
            </Text>
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Divider borderWidth={1.5} mb={4} />
          <Text fontSize="lg" fontWeight={400} color="neutral.700">
            {t('content')
              .split('\n')
              .map((line, index) => (
                <Fragment key={index}>
                  {line}
                  <br />
                </Fragment>
              ))}
          </Text>
          <Divider borderWidth={1.5} my={4} />

          <Checkbox
            isChecked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          >
            {t('accept')}{' '}
            <Text
              as="a"
              href={links.termsOfUse}
              color="brand.500"
              fontWeight="Bold"
              target="_blank"
            >
              {t('terms')}
            </Text>{' '}
            {t('and')}{' '}
            <Text
              as="a"
              href={links.privacyPolicy}
              color="brand.500"
              fontWeight="Bold"
              target="_blank"
            >
              {t('privacyPolicy')}
            </Text>
          </Checkbox>
        </ModalBody>

        <ModalFooter display="flex" gap={10} pb={6}>
          <Button
            variant="outline"
            colorScheme="brand"
            w="full"
            as="a"
            href={links.termsOfUse}
            download
            target="_blank"
            leftIcon={<Icon as={FileDown} />}
          >
            {t('downloadTerms')}
          </Button>
          <Button
            colorScheme="brand"
            type="submit"
            w="full"
            onClick={onSubmit}
            isLoading={isLoading}
            isDisabled={!isChecked}
          >
            {t('accept')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
